import { render } from "./ThreadPrint.vue?vue&type=template&id=77b8ca8f&scoped=true&ts=true"
import script from "./ThreadPrint.vue?vue&type=script&lang=ts"
export * from "./ThreadPrint.vue?vue&type=script&lang=ts"

import "./ThreadPrint.vue?vue&type=style&index=0&id=77b8ca8f&scoped=true&lang=css"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b8ca8f"]])

export default __exports__